var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgHeartPulseDefault = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  "aria-hidden": true,
  viewBox: "0 0 16 14",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.975.599c.275 0 .525.2.6.45l1.975 7.6.675-1.425a1.4 1.4 0 0 1 1.275-.825h2.9c.325 0 .6.275.6.6 0 .35-.275.6-.6.6h-2.9c-.075 0-.15.05-.175.125l-1.4 2.95c-.1.225-.35.35-.6.325a.62.62 0 0 1-.525-.425L8.05 3.849l-1.875 9.075a.59.59 0 0 1-.575.475.57.57 0 0 1-.6-.425L3.575 7.749a.22.22 0 0 0-.2-.15H.6c-.35 0-.6-.25-.6-.6 0-.325.25-.6.6-.6h2.775c.625 0 1.175.425 1.35 1.05l.775 2.8 1.9-9.15c.05-.275.3-.475.575-.5"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeartPulseDefault);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;